"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoverDataActionPayloadFactoryFromJS = exports.RecoverDataActionPayloadFactory = void 0;
const tslib_1 = require("tslib");
const LayoutCreatorEntities = tslib_1.__importStar(require("@bimser/components/dist/BCLayoutCreator/common/entities"));
const immutable_1 = require("immutable");
exports.RecoverDataActionPayloadFactory = (0, immutable_1.Record)({
    windowId: null,
    data: (0, immutable_1.Map)()
});
const RecoverDataActionPayloadFactoryFromJS = function (data) {
    const _data = {};
    for (const key in data.data) {
        const item = data.data[key];
        _data[key] = LayoutCreatorEntities.LayoutDataItemFactoryFromJS(item);
    }
    return (0, exports.RecoverDataActionPayloadFactory)({
        windowId: data.windowId,
        data: (0, immutable_1.Map)(_data)
    });
};
exports.RecoverDataActionPayloadFactoryFromJS = RecoverDataActionPayloadFactoryFromJS;
//# sourceMappingURL=IRecoverDataActionPayload.js.map